// Heavily based on https://github.com/jsonwebtoken/jsonwebtoken.github.io/blob/c7cc044e007322350785c51c3b52b01799833bb7/src/editor/jwt.js#L122-L151
function jwt(token) {
  if (!token) {
    return null;
  }

  var result = {
    header: {},
    payload: {}
  };
  var split = token.split('.');

  try {
    result.header = JSON.parse(atob(split[0]));
  } catch (_) {
    return null;
  }

  try {
    result.payload = JSON.parse(atob(split[1]));
  } catch (_) {
    return null;
  }

  return result;
}

export default jwt;
//# sourceMappingURL=jwt.esm.js.map
